<template>
<div class="SystemCodeSet">
  <ul>
    <li v-for="formData in formDatas" :key="formData.id">
      <h3>
        <span>{{ formData.name }}</span>
        <el-checkbox v-model="formData.status" :true-label="1" :false-label="0">按照以下规则生成</el-checkbox>
      </h3>
      <section>
        <div v-for="rule in formData.list" :key="rule.id">
          <span class="label">{{ rule.name }}：</span>
          <el-input v-model="rule.prefix" class="prefix" size="mini" />
          <span class="links">+</span>
<!--          <el-input v-model="rule.middle" class="middle" size="mini" />
          <span class="links">+</span>-->
          <el-input v-model="rule.suffix" class="suffix" size="mini" />
        </div>
      </section>
      <el-alert :title="formData.remarks" type="warning" :closable="false"></el-alert>
    </li>
  </ul>
  <div style="text-align: center">
    <el-button @click="save" type="primary" v-points>保存</el-button>
  </div>
</div>
</template>

<script>
import {
  codeSetQuery,
  codeSetUpdata,
} from "@/api/systemSetup";
export default {
  name: "SystemCodeSet",
  data() {
    return {
      // 房源编号
      formDatas: [
        {
          "id": 17,
          "enterpriseCode": "guofang",
          "businessType": "01",
          "status": 1,
          "prefix": null,
          "middle": null,
          "suffix": null,
          "parentId": 0,
          "name": "房源编号",
          "remarks": "只能更改编号前缀，前缀不能重复，不能超过4个字母，也可以是数字。",
          "list": [
            {
              "id": 20,
              "enterpriseCode": "guofang",
              "businessType": "0101",
              "status": 1,
              "prefix": "A",
              "middle": null,
              "suffix": "000001",
              "parentId": 17,
              "name": "二手房（除商业）房源编号",
              "remarks": null,
              "list": null,
              "currCode": "00000"
            },
          ],
          "currCode": "00000"
        }
      ],
    }
  },
  methods: {
    save() {
      console.log(JSON.parse(JSON.stringify(this.formDatas)));
      const param = {
        pcode: 'jsonString',
        list: JSON.stringify(this.formDatas)
      }
      // console.log(param);
      this.$post(codeSetUpdata, param).then((res) => {
        if (!res.success) {
          this.$message.error(res.msg)
          return
        }
        this.$message({
          message: res.msg,
          type: "success",
        });
      })
    }
  },
  created() {
    this.$post(codeSetQuery, {}).then(res => {
      if (res.success) {
        this.formDatas = res.data
      }
    });
  }
}
</script>

<style scoped lang="less">
.SystemCodeSet {
  background-color: #fff;
  padding: 20px;
  li {
    margin-bottom: 30px;
    h3 {
      margin-bottom: 10px;
      .el-checkbox {
        margin-left: 30px;
      }
    }
  }
  section{
    margin-bottom: 10px;
    > div {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      //justify-content: ;
      .label {
        width: 250px;
        text-align: right;
      }
      .links {
        margin: 0 5px;
      }
      .el-input {
        width: 100px;
      }
    }
  }
}
</style>